<template>
  <div>
    <div :style='{backgroundImage: `url("${img}")`}' class="boom"></div>
    <div class="name">{{name}}</div>
  </div>
</template>
<script>
export default {
  props: ['img','name'],
  mounted () {}
}
</script>

<style lang="less" scoped>
@animation-time:1.5s;
@close-time:1.5s;

.boom {
  width: 86px;
  height: 86px;
  background-repeat: no-repeat;
  margin: 0 auto;
  background-position: 0 0;
  background-size: cover;
  padding: 0;
  overflow-x: hidden;
  will-change: background;
  transform-style: preserve-3d;
  backface-visibility: hidden;
  animation: boom-close @close-time steps(50) forwards;
  &:hover{
    animation: boom-open @animation-time steps(50) forwards!important;
  }
}
.name{
  font-weight: bold;
  font-size: 20px;
  font-family: 'SY-bold';
  cursor: pointer;
  margin-top: 10px;
}

@keyframes boom-open {
  0% {
    background-position: 0 0px;

  }
  100% {
    background-position: -4300px 0px;
  }
}

@keyframes boom-close {
  0% {
    background-position: -4300px 0px;
  }
  100% {
    background-position: 0 0px;
  }
}

</style>
